import React, { Component } from 'react';
import $
	from "jquery";
import 'antd/dist/antd.css';
import './../App.css';
import CreateSection
	from "./CreateSection";
import { Icon } from 'antd';
import update
	from 'immutability-helper';
import ManagerHotspot
	from './../includes/ManagerHotspot';
import contenedorVideo
	from './../constants/contenedorVideo';
import { instanceOf } from 'prop-types';
import {
	Cookies,
	withCookies
} from 'react-cookie';
import AccesibilityActions
	from './AccesibilityActions';
import PauHelpers
	from "./PauHelpers";
import { version_compare } from "../constants/version_compare";
import { eventClickPauActions } from "../assets/js/MenuPauPrincipal";

$( "body" )
	.prepend( contenedorVideo );

class Main extends Component {

	static propTypes = {
		cookies : instanceOf( Cookies ).isRequired
	};

	constructor( props ) {

		super( props );

		const { cookies, globals, fetchUrls } = props;

		this.state = {
			settings          : cookies.get( 'settings' ) || null,
			shows             : null,
			hotspots          : null,
			globals,
			ico_pau           : null,
			ico_principal_pau : null,
			ico_ready         : null
		};

		this.managerHotspot = new ManagerHotspot( global.licenseState );

		this.sections = null;
		this.fetchUrls = fetchUrls;

		if ( this.state.settings ) {

			AccesibilityActions.initActions( {
				settings  : this.state.settings,
				pauDirUrl : globals.pau_PluginDirUrl
			} );
			// console.log( this.state.settings );

		}

	};

	spinLoader() {
		return <Icon
			type="loading"
			style={{ fontSize : 24 }}
			spin/>;
	}

	componentWillMount() {

		// console.log( "componentWillMount" );
		if ( this.state.settings === null ) {
			this.execSettings();
		} else {

			let { cookies } = this.props;

			let $pauMainAcces      = $( "#pauMainAcces" ),
				data_pau_version   = $pauMainAcces.attr( 'pau-version' ),
				cookie_pau_version = cookies.get( 'pau_version' ),
				is_vesion_update   = version_compare( data_pau_version, cookie_pau_version, ">" );

			if ( is_vesion_update ) {

				cookies.set( "pau_version", data_pau_version, { path : "/" } );
				this.execSettings( is_vesion_update );

				// Falta script para cambiar a 0 el valor en la base de datos

			}

		}

		this.execShows();
		this.execHotspots();
		this.execPageContent();

	}

	componentDidMount() {

		// let $pauSvgRender = $( '.pauSvgRender' );

		// console.log( $pauSvgRender );

		let $pauMainAcces     = $( "#pauMainAcces" ),
			dataUrl           = $pauMainAcces.attr( "data-url" ),
			mediaDirHeader    = dataUrl + "multimedia/pau/react/header/",
			ico_principal_pau = mediaDirHeader + "ico-principal-pau.svg",
			ico_pau           = mediaDirHeader + "ico-pau.svg",
			$this             = this;

		/*$.each( $pauSvgRender, function ( key, $el ) {

			let $elem  = $( $el ),
				urlSvg = $elem.attr( 'pau-url-svg' );

			fetch( urlSvg )
				.then( res => {
					return res.blob();
				} )
				.then( blob => {

					var lector = new FileReader();

					lector.onload = function ( e ) {
						let contenido = e.target.result;
					};

					lector.readAsText( blob );

				} );

		} );*/

		fetch( ico_principal_pau )
			.then( res => {
				return res.blob();
			} )
			.then( blob => {

				let lector = new FileReader();

				lector.onload = function ( e ) {
					let contenido = e.target.result;
					$this.setState( update( $this.state, {
						ico_principal_pau : { $set : contenido }
					} ) );
				};

				lector.readAsText( blob );

			} );

		fetch( ico_pau )
			.then( res => {
				return res.blob();
			} )
			.then( blob => {

				let lector = new FileReader();

				lector.onload = function ( e ) {
					let contenido = e.target.result;
					$this.setState( update( $this.state, {
						ico_pau : { $set : contenido }
					} ) );
				};

				lector.readAsText( blob );

			} );

	}

	componentDidUpdate() {

		if ( this.state.ico_pau && this.state.ico_principal_pau ) {

			if ( ! this.state.ico_ready ) {

				document.querySelector( '.iconPauAcces' ).innerHTML = this.state.ico_principal_pau;

				$( document ).on( 'click', '#pau-pestana, .eventClickPauActions', {
					ico_pau           : this.state.ico_pau,
					ico_principal_pau : this.state.ico_principal_pau
				}, eventClickPauActions );

				this.setState( update( this.state, {
					ico_ready : { $set : true }
				} ) );

			}

		}

	}

	getValuesSettings( settings ) {

		let keys = Object.keys( settings ),
			settingFinal;

		keys.forEach( setting => {
			let set = settings[ setting ];
		} );

	}

	getValues( setting, key ) {

		if ( !setting ) return false;

		if ( setting.hasOwnProperty( key ) ) {

			let $key = setting[ key ];

			if ( typeof setting === "undefined" ) return false;

			if ( $key === "on" ) {
				return true;
			} else if ( $.isNumeric( $key ) ) {
				return parseInt( $key, 10 );
			}

		}

		return false;

	}

	componentWillUpdate( prevProps, prevState ) {

		// console.log( "componentWillUpdate" );
		// console.log( "prevProps: " );
		// console.log( prevProps );
		// console.log( "prevState: " );
		// console.log( prevState );
		//
		// this.sections = null;
		// console.log( this.sections );
		// console.log( prevState.settings );
		// this.sections = this.getSections( prevState.settings );
		// console.log( this.sections );
		// console.log( this.sections[ 3 ].items[ 0 ] );

	}

	getSettings( settings ) {

		// Perfiles

		const perfil_defecto = {
			value : settings.cg_perfil_defecto.value,
			show  : settings.cg_perfil_defecto.show || false
		};

		// General

		const geral_todo = {
			value : this.getValues( settings.cg_geral_todo, "value" ),
			show  : this.getValues( settings.cg_geral_todo, "show" )
		};

		const geral_sonido = {
			value : this.getValues( settings.cg_geral_sonido, "value" ),
			show  : this.getValues( settings.cg_geral_sonido, "show" )
		};

		const geral_video = {
			value : this.getValues( settings.cg_geral_video, "value" ),
			show  : this.getValues( settings.cg_geral_video, "show" )
		};

		const geral_lectura = {
			value : this.getValues( settings.cg_geral_lectura, "value" ),
			show  : this.getValues( settings.cg_geral_lectura, "show" )
		};

		// Navegación

		const nav_bigcursor = {
			value : this.getValues( settings.cg_nav_bigcursor, "value" ),
			show  : this.getValues( settings.cg_nav_bigcursor, "show" )
		};

		const nav_clic = {
			value : this.getValues( settings.cg_nav_clic, "value" ),
			show  : this.getValues( settings.cg_nav_clic, "show" )
		};

		const nav_donde = {
			value : this.getValues( settings.cg_nav_donde, "value" ),
			show  : this.getValues( settings.cg_nav_donde, "show" )
		};

		const nav_zoom = {
			value : this.getValues( settings.cg_nav_zoom, "value" ),
			show  : this.getValues( settings.cg_nav_zoom, "show" )
		};

		// Fonts

		const font_size = {
			value : this.getValues( settings.cg_font_size, "value" ),
			show  : this.getValues( settings.cg_font_size, "show" )
		};

		const font_legible = { show : this.getValues( settings.cg_font_legible, "show" ) };
		const font_dislexia = { show : this.getValues( settings.cg_font_dislexia, "show" ) };

		const font_dislexia_legible = {
			value : settings.cg_font_dislexia_legible ? settings.cg_font_dislexia_legible.value : ""
		};

		const font_resaltar_links = {
			value : this.getValues( settings.cg_font_resaltar_links, "value" ),
			show  : this.getValues( settings.cg_font_resaltar_links, "show" )
		};

		// Visual

		const visual_colors_bn = { show : this.getValues( settings.cg_visual_colors_bn, "show" ) };
		const visual_colors_invert = { show : this.getValues( settings.cg_visual_colors_invert, "show" ) };

		const visual_colors = {
			value : settings.cg_visual_colors ? settings.cg_visual_colors.value : ""
		};

		const visual_resaltar_focus = {
			value : this.getValues( settings.cg_visual_resaltar_focus, "value" ),
			show  : this.getValues( settings.cg_visual_resaltar_focus, "show" )
		};

		// Otros

		const zoom_pau = {
			value : this.getValues( settings.cg_zoom_pau, "value" ),
			show  : this.getValues( settings.cg_zoom_pau, "show" )
		};

		return {
			perfil_defecto,
			font_dislexia_legible,
			visual_colors,
			geral_todo,
			geral_sonido,
			geral_video,
			geral_lectura,
			nav_bigcursor,
			nav_clic,
			nav_donde,
			nav_zoom,
			font_size,
			font_legible,
			font_dislexia,
			font_resaltar_links,
			visual_colors_bn,
			visual_colors_invert,
			visual_resaltar_focus,
			zoom_pau
		};

	}

	execShows() {

		fetch( this.fetchUrls.urlSettings )
			.then( res => res.json() )
			.then( data => {

				const { settings } = data;
				const sets = this.getSettings( settings );

				this.setState( update( this.state, {
					shows : { $set : sets }
				} ) );

			} )
			.catch( error => console.log( error ) );

	}

	/**
	 * Método que sirve para obtener los
	 * valores de configuración mediante
	 * la API de Wordpress
	 */
	execSettings( is_react_update = false ) {

		const { globals } = this.state;

		fetch( this.fetchUrls.urlSettings )
			.then( res => res.json() )
			.then( data => {

				const { settings } = data;
				let sets = this.getSettings( settings );
				const { cookies } = this.props;

				if ( is_react_update ) {

					let old_settings = cookies.get( "settings" ) || {};
					sets = PauHelpers.filterKeys( old_settings, sets );

				}

				cookies.remove( "settings", { path : "/" } );
				cookies.set( 'settings', sets, { path : "/" } );

				if ( sets ) {
					AccesibilityActions.initActions( {
						settings  : sets,
						pauDirUrl : globals.pau_PluginDirUrl
					} );
				}

				this.setState( update( this.state, {
					settings : { $set : sets },
					// sections : { $set : this.getSections( sets ) }
				} ) );

			} )
			.catch( error => console.log( error ) );

	}

	execHotspots() {

		fetch( this.fetchUrls.urlHotspots )
			.then( res => res.json() )
			.then( data => {

				this.setState( update( this.state, {
					hotspots : { $set : data }
				} ) );

				this.managerHotspot.init( data );

			} )
			.catch( error => console.log( error ) );

	}

	execPageContent() {

		let $pauMainAcces = $( "#pauMainAcces" ),
			pageID        = $pauMainAcces.attr( "data-paupageid" );

		fetch( `${this.fetchUrls.urlHotspots}/page/${pageID}` )
			.then( res => {
				return res.json();
			} )
			.then( data => {

				if ( data.length ) {

					for ( const i in data ) {

						let hotspot = data[ i ];

						if (
							hotspot.type === "page-content" &&
							hotspot.estado === "active"
						) {
							this.managerHotspot.typePageContent( hotspot );
							break;
						}

					}

				}

			} )
			.catch( error => console.log( error ) );

	}

	render() {

		const { settings, globals, shows } = this.state;

		return settings && shows ?
			<CreateSection
				settings={settings}
				globals={globals}
				shows={shows}/> : this.spinLoader();

	}

}

export default withCookies( Main );



// WEBPACK FOOTER //
// ./src/includes/Main.js